import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { Button, InputLabel, InputAdornment, FormControl, OutlinedInput, Typography } from '@mui/material';
export const AMFModalContent = observer(_ref => {
  let defaultAdminFee = _ref.defaultAdminFee,
    adminFee = _ref.adminFee,
    residencyId = _ref.residencyId,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(adminFee ? adminFee : null),
    _useState2 = _slicedToArray(_useState, 2),
    currentAdminFee = _useState2[0],
    setCurrentAdminFee = _useState2[1];
  const handleSave = () => {
    store.addNewProperty.residentsSetup.handleAdminFee(residencyId, "".concat(currentAdminFee));
    handleModalClose();
  };
  const handleRelink = () => {
    store.addNewProperty.residentsSetup.handleAdminFee(residencyId, null);
    handleModalClose();
  };
  const handleChange = e => {
    if (+e.target.value <= 99.99 && /^\d+([.,]\d{0,2})?$|^$/.test(+e.target.value)) setCurrentAdminFee(e.target.value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.setting
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingDetail
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingDetailMain
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  }), "Admin fee:", ' ', /*#__PURE__*/React.createElement("span", null, adminFee !== null && adminFee !== 'null' && +adminFee !== +defaultAdminFee ? "$".concat(adminFee) : defaultAdminFee ? "$".concat(defaultAdminFee) : 'N/A')), adminFee !== null && adminFee !== 'null' && +adminFee !== +defaultAdminFee && /*#__PURE__*/React.createElement("div", {
    className: classes.settingDetailCustom
  }, "Custom fee")), /*#__PURE__*/React.createElement("div", {
    className: classes.settingInput
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "resident-payment"
  }, t('unit_modal.custom_fee')), /*#__PURE__*/React.createElement(OutlinedInput, {
    label: t('unit_modal.custom_fee'),
    id: "resident-payment",
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "number",
    value: currentAdminFee
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.feeRelink, " ").concat(!!adminFee ? 'relink' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.feeRelinkText
  }, /*#__PURE__*/React.createElement(Icon, {
    type: !!adminFee ? 'relink' : 'unlink'
  }), /*#__PURE__*/React.createElement(Typography, {
    margin: "0 10px",
    variant: "h6"
  }, t("unit_modal.fee_".concat([!!adminFee ? 'relink' : 'unrelink'])))), !!adminFee ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleRelink(),
    size: "medium",
    variant: "actionIcon",
    'custom-attribute': '136-admin-fee-setup'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "relink"
  }), "Re-link") : null)), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => handleModalClose(),
    'custom-attribute': '137-admin-fee-setup'
  }, t('Cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: () => handleSave(),
    'custom-attribute': '138-admin-fee-setup'
  }, t('Save')))))));
});